import { all } from "redux-saga/effects";
import { watchNotificationList } from "../redux/notification";
import { watcherTaskApp } from "../redux/task-app";

export default function* rootSagas() {
    yield all([
        watcherTaskApp(),
        watchNotificationList()
    ])
}